import { BrowserRouter } from 'react-router';
import { AppRoutes } from './app/routes';
import { SessionProvider } from './app/auth/session';
import { UpdatePrompt } from './pwa/UpdatePrompt';

export function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <AppRoutes />
      </SessionProvider>
      <UpdatePrompt />
    </BrowserRouter>
  );
}
